class CollectionSort extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.optionList = this.querySelector('ul');
  }

  connectedCallback() {
    document.addEventListener('click', (e) => this.handleClickOutside(e));
    if(this.optionList) this.optionList.addEventListener('click', (e) => this.handleOptionClick(e));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleOptionClick(e) {
    if (e.target.dataset && e.target.dataset.sortName) {
      const input = this.querySelector('input[name="sort_by"]');
      if (input) {
        input.value = e.target.dataset.sortName;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) this.close();
  }

  close() {
    this.details.removeAttribute('open');
  }
}
if (!customElements.get('collection-sort')) customElements.define('collection-sort', CollectionSort);
